import tw, { css, styled } from 'twin.macro';

import type { PageVariant } from './Page.types';
import { isViewportPageVariant } from './pageVariantGuards';

type StyledPageRootProps = { $variant: PageVariant };

export const StyledPageRoot = styled.div<StyledPageRootProps>`
	${({ $variant }) =>
		isViewportPageVariant($variant) &&
		css`
			${tw`flex flex-col`}
		`}
	${({ $variant }) =>
		$variant === 'viewportWithFooter' &&
		css`
			${tw`justify-between`}
		`}
`;
